import { createRoute, lazyRouteComponent } from '@tanstack/react-router';
import { z } from 'zod';

import { clientApplicationsRoute } from '../route';

export const clientValidActivationsSearchSchema = z.object({
	openedDeviceUuid: z.string().optional(),
});

export const clientValidActivationsRoute = createRoute({
	getParentRoute: () => clientApplicationsRoute,
	path: '/valid-activations',
	component: lazyRouteComponent(
		() => import('./ClientValidActivationsPage'),
		'ClientValidActivationsPage',
	),
	validateSearch: clientValidActivationsSearchSchema,
});
